<template>
  <span class="nt-video-duration" @click="togglePlayPause()" >
    <video v-show="false" :id="id" ref="video" 
      preload="metadata"
      webkit-playsinline="true" playsinline="true"
      width="0px" height="0px" 
       frameborder="0">
      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>    
    {{this.computedDuration}} 
  </span>
</template>

<script>
  export default {
    name: 'NtVideoDuration',
    props: {
      videoUrl: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        player: null,
        duration: 0
      }
    },
    computed: {
      computedDuration() {
        const minutes = Math.floor(this.duration / 60)
        const seconds = this.duration - minutes * 60
        return this.duration > 0 ? `${minutes}:${(seconds < 10 ? '0' : '') + Math.trunc(seconds)}  min` : ''
      }
    },
    mounted() {
      this.player = this.$refs.video
      this.player.addEventListener('loadedmetadata', () => {
        this.duration = this.player.duration
      })
    }
  }
</script>
